import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import {useTranslation} from "react-i18next";
import FormButton from "../../../components/forms/FormButton";
import {Title} from "../../../components/components";
import ZoneForm from "../../../components/zones/ZoneForm";
import {useCreateZoneMutation} from "../../../api/zoneApiSlice";

function NewZone(props) {
  const history = useHistory();
  const { t } = useTranslation();
  const [submitButtonProps, setSubmitButtonProps] = useState({})
  const [createZone] = useCreateZoneMutation()
  const goToZone = (data) => history.push(`/zones/${data.key}`)

  const submitProps = {
    handleSubmit: (data) => {
      createZone(data).unwrap()
        .then(goToZone)
        .catch(error => {})
    },
    errors: {}
  }

  return (
    <>
      <Title
        main={t("menu.zones")}
        sub={t("new")}
        group={false}
        backPath="/zones">
        <FormButton submit {...submitButtonProps}/>
      </Title>
      <ZoneForm {...submitProps} setSubmitButtonProps={setSubmitButtonProps} />
    </>
  )
}

export default NewZone
